module.exports = __webpack_public_path__ + "media/images/logo/gampla_logo-379b942b37842b210a596de4ec69da33.png";